/**
 * @desc 获取当前流程所有任务
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<Array<defs.activiti.ActivitiTaskInfoDto>>;
export function request(
  params: API.activiti.activiti.getTaskInfos.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/activitiFacade/getTaskInfos`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
